/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateRecurringInvoiceBody,
  Error,
  GetRecurringInvoices200,
  GetRecurringInvoicesParams,
  RecurringInvoice,
  UpdateRecurringInvoiceBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Create a new recurring invoice schedule.
Link an existing invoice as the template and configure the generation frequency.
The source invoice's data (items, customer, notes) is used when generating new invoices.
 * @summary Create a recurring invoice
 */
export type createRecurringInvoiceResponse201 = {
  data: RecurringInvoice
  status: 201
}

export type createRecurringInvoiceResponse400 = {
  data: Error
  status: 400
}

export type createRecurringInvoiceResponse401 = {
  data: Error
  status: 401
}

export type createRecurringInvoiceResponse403 = {
  data: Error
  status: 403
}

export type createRecurringInvoiceResponse404 = {
  data: Error
  status: 404
}

export type createRecurringInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type createRecurringInvoiceResponse500 = {
  data: Error
  status: 500
}

export type createRecurringInvoiceResponseSuccess = (createRecurringInvoiceResponse201) & {
  headers: Headers;
};
export type createRecurringInvoiceResponseError = (createRecurringInvoiceResponse400 | createRecurringInvoiceResponse401 | createRecurringInvoiceResponse403 | createRecurringInvoiceResponse404 | createRecurringInvoiceResponse422 | createRecurringInvoiceResponse500) & {
  headers: Headers;
};

export type createRecurringInvoiceResponse = (createRecurringInvoiceResponseSuccess | createRecurringInvoiceResponseError)

export const getCreateRecurringInvoiceUrl = () => {


  

  return `/recurring-invoices`
}

export const createRecurringInvoice = async (createRecurringInvoiceBody: CreateRecurringInvoiceBody, options?: RequestInit): Promise<createRecurringInvoiceResponse> => {
  
  return customFetch<createRecurringInvoiceResponse>(getCreateRecurringInvoiceUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createRecurringInvoiceBody,)
  }
);}
  

/**
 * Retrieve a paginated list of recurring invoice schedules with optional filtering and sorting.
Supports cursor-based pagination, flexible JSON querying with MongoDB-style operators, full-text search, and sorting.
 * @summary List all recurring invoices
 */
export type getRecurringInvoicesResponse200 = {
  data: GetRecurringInvoices200
  status: 200
}

export type getRecurringInvoicesResponse400 = {
  data: Error
  status: 400
}

export type getRecurringInvoicesResponse401 = {
  data: Error
  status: 401
}

export type getRecurringInvoicesResponse403 = {
  data: Error
  status: 403
}

export type getRecurringInvoicesResponse404 = {
  data: Error
  status: 404
}

export type getRecurringInvoicesResponse500 = {
  data: Error
  status: 500
}

export type getRecurringInvoicesResponseSuccess = (getRecurringInvoicesResponse200) & {
  headers: Headers;
};
export type getRecurringInvoicesResponseError = (getRecurringInvoicesResponse400 | getRecurringInvoicesResponse401 | getRecurringInvoicesResponse403 | getRecurringInvoicesResponse404 | getRecurringInvoicesResponse500) & {
  headers: Headers;
};

export type getRecurringInvoicesResponse = (getRecurringInvoicesResponseSuccess | getRecurringInvoicesResponseError)

export const getGetRecurringInvoicesUrl = (params?: GetRecurringInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/recurring-invoices?${stringifiedParams}` : `/recurring-invoices`
}

export const getRecurringInvoices = async (params?: GetRecurringInvoicesParams, options?: RequestInit): Promise<getRecurringInvoicesResponse> => {
  
  return customFetch<getRecurringInvoicesResponse>(getGetRecurringInvoicesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve a single recurring invoice schedule by its unique identifier.
 * @summary Get recurring invoice by ID
 */
export type getRecurringInvoiceByIdResponse200 = {
  data: RecurringInvoice
  status: 200
}

export type getRecurringInvoiceByIdResponse401 = {
  data: Error
  status: 401
}

export type getRecurringInvoiceByIdResponse403 = {
  data: Error
  status: 403
}

export type getRecurringInvoiceByIdResponse404 = {
  data: Error
  status: 404
}

export type getRecurringInvoiceByIdResponse500 = {
  data: Error
  status: 500
}

export type getRecurringInvoiceByIdResponseSuccess = (getRecurringInvoiceByIdResponse200) & {
  headers: Headers;
};
export type getRecurringInvoiceByIdResponseError = (getRecurringInvoiceByIdResponse401 | getRecurringInvoiceByIdResponse403 | getRecurringInvoiceByIdResponse404 | getRecurringInvoiceByIdResponse500) & {
  headers: Headers;
};

export type getRecurringInvoiceByIdResponse = (getRecurringInvoiceByIdResponseSuccess | getRecurringInvoiceByIdResponseError)

export const getGetRecurringInvoiceByIdUrl = (id: string,) => {


  

  return `/recurring-invoices/${id}`
}

export const getRecurringInvoiceById = async (id: string, options?: RequestInit): Promise<getRecurringInvoiceByIdResponse> => {
  
  return customFetch<getRecurringInvoiceByIdResponse>(getGetRecurringInvoiceByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update an existing recurring invoice schedule.
Only the provided fields will be updated.
Schedule changes automatically recalculate the next run date.
 * @summary Update a recurring invoice
 */
export type updateRecurringInvoiceResponse200 = {
  data: RecurringInvoice
  status: 200
}

export type updateRecurringInvoiceResponse400 = {
  data: Error
  status: 400
}

export type updateRecurringInvoiceResponse401 = {
  data: Error
  status: 401
}

export type updateRecurringInvoiceResponse403 = {
  data: Error
  status: 403
}

export type updateRecurringInvoiceResponse404 = {
  data: Error
  status: 404
}

export type updateRecurringInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type updateRecurringInvoiceResponse500 = {
  data: Error
  status: 500
}

export type updateRecurringInvoiceResponseSuccess = (updateRecurringInvoiceResponse200) & {
  headers: Headers;
};
export type updateRecurringInvoiceResponseError = (updateRecurringInvoiceResponse400 | updateRecurringInvoiceResponse401 | updateRecurringInvoiceResponse403 | updateRecurringInvoiceResponse404 | updateRecurringInvoiceResponse422 | updateRecurringInvoiceResponse500) & {
  headers: Headers;
};

export type updateRecurringInvoiceResponse = (updateRecurringInvoiceResponseSuccess | updateRecurringInvoiceResponseError)

export const getUpdateRecurringInvoiceUrl = (id: string,) => {


  

  return `/recurring-invoices/${id}`
}

export const updateRecurringInvoice = async (id: string,
    updateRecurringInvoiceBody: UpdateRecurringInvoiceBody, options?: RequestInit): Promise<updateRecurringInvoiceResponse> => {
  
  return customFetch<updateRecurringInvoiceResponse>(getUpdateRecurringInvoiceUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateRecurringInvoiceBody,)
  }
);}
  

/**
 * Soft delete a recurring invoice schedule. The schedule is moved to the trash and can be restored.
 * @summary Delete a recurring invoice
 */
export type deleteRecurringInvoiceResponse204 = {
  data: void
  status: 204
}

export type deleteRecurringInvoiceResponse400 = {
  data: Error
  status: 400
}

export type deleteRecurringInvoiceResponse401 = {
  data: Error
  status: 401
}

export type deleteRecurringInvoiceResponse403 = {
  data: Error
  status: 403
}

export type deleteRecurringInvoiceResponse404 = {
  data: Error
  status: 404
}

export type deleteRecurringInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteRecurringInvoiceResponse500 = {
  data: Error
  status: 500
}

export type deleteRecurringInvoiceResponseSuccess = (deleteRecurringInvoiceResponse204) & {
  headers: Headers;
};
export type deleteRecurringInvoiceResponseError = (deleteRecurringInvoiceResponse400 | deleteRecurringInvoiceResponse401 | deleteRecurringInvoiceResponse403 | deleteRecurringInvoiceResponse404 | deleteRecurringInvoiceResponse422 | deleteRecurringInvoiceResponse500) & {
  headers: Headers;
};

export type deleteRecurringInvoiceResponse = (deleteRecurringInvoiceResponseSuccess | deleteRecurringInvoiceResponseError)

export const getDeleteRecurringInvoiceUrl = (id: string,) => {


  

  return `/recurring-invoices/${id}`
}

export const deleteRecurringInvoice = async (id: string, options?: RequestInit): Promise<deleteRecurringInvoiceResponse> => {
  
  return customFetch<deleteRecurringInvoiceResponse>(getDeleteRecurringInvoiceUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Restore a soft-deleted recurring invoice schedule from the trash.
 * @summary Restore a deleted recurring invoice
 */
export type restoreRecurringInvoiceResponse200 = {
  data: RecurringInvoice
  status: 200
}

export type restoreRecurringInvoiceResponse400 = {
  data: Error
  status: 400
}

export type restoreRecurringInvoiceResponse401 = {
  data: Error
  status: 401
}

export type restoreRecurringInvoiceResponse403 = {
  data: Error
  status: 403
}

export type restoreRecurringInvoiceResponse404 = {
  data: Error
  status: 404
}

export type restoreRecurringInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type restoreRecurringInvoiceResponse500 = {
  data: Error
  status: 500
}

export type restoreRecurringInvoiceResponseSuccess = (restoreRecurringInvoiceResponse200) & {
  headers: Headers;
};
export type restoreRecurringInvoiceResponseError = (restoreRecurringInvoiceResponse400 | restoreRecurringInvoiceResponse401 | restoreRecurringInvoiceResponse403 | restoreRecurringInvoiceResponse404 | restoreRecurringInvoiceResponse422 | restoreRecurringInvoiceResponse500) & {
  headers: Headers;
};

export type restoreRecurringInvoiceResponse = (restoreRecurringInvoiceResponseSuccess | restoreRecurringInvoiceResponseError)

export const getRestoreRecurringInvoiceUrl = (id: string,) => {


  

  return `/recurring-invoices/${id}/restore`
}

export const restoreRecurringInvoice = async (id: string, options?: RequestInit): Promise<restoreRecurringInvoiceResponse> => {
  
  return customFetch<restoreRecurringInvoiceResponse>(getRestoreRecurringInvoiceUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Permanently delete a soft-deleted recurring invoice schedule. Only schedules in the trash can be permanently deleted.
 * @summary Permanently delete a recurring invoice
 */
export type permanentDeleteRecurringInvoiceResponse204 = {
  data: void
  status: 204
}

export type permanentDeleteRecurringInvoiceResponse400 = {
  data: Error
  status: 400
}

export type permanentDeleteRecurringInvoiceResponse401 = {
  data: Error
  status: 401
}

export type permanentDeleteRecurringInvoiceResponse403 = {
  data: Error
  status: 403
}

export type permanentDeleteRecurringInvoiceResponse404 = {
  data: Error
  status: 404
}

export type permanentDeleteRecurringInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type permanentDeleteRecurringInvoiceResponse500 = {
  data: Error
  status: 500
}

export type permanentDeleteRecurringInvoiceResponseSuccess = (permanentDeleteRecurringInvoiceResponse204) & {
  headers: Headers;
};
export type permanentDeleteRecurringInvoiceResponseError = (permanentDeleteRecurringInvoiceResponse400 | permanentDeleteRecurringInvoiceResponse401 | permanentDeleteRecurringInvoiceResponse403 | permanentDeleteRecurringInvoiceResponse404 | permanentDeleteRecurringInvoiceResponse422 | permanentDeleteRecurringInvoiceResponse500) & {
  headers: Headers;
};

export type permanentDeleteRecurringInvoiceResponse = (permanentDeleteRecurringInvoiceResponseSuccess | permanentDeleteRecurringInvoiceResponseError)

export const getPermanentDeleteRecurringInvoiceUrl = (id: string,) => {


  

  return `/recurring-invoices/${id}/permanent`
}

export const permanentDeleteRecurringInvoice = async (id: string, options?: RequestInit): Promise<permanentDeleteRecurringInvoiceResponse> => {
  
  return customFetch<permanentDeleteRecurringInvoiceResponse>(getPermanentDeleteRecurringInvoiceUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Pause an active recurring invoice schedule. No invoices will be generated while paused. The next run date is cleared.
 * @summary Pause a recurring invoice
 */
export type pauseRecurringInvoiceResponse200 = {
  data: RecurringInvoice
  status: 200
}

export type pauseRecurringInvoiceResponse400 = {
  data: Error
  status: 400
}

export type pauseRecurringInvoiceResponse401 = {
  data: Error
  status: 401
}

export type pauseRecurringInvoiceResponse403 = {
  data: Error
  status: 403
}

export type pauseRecurringInvoiceResponse404 = {
  data: Error
  status: 404
}

export type pauseRecurringInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type pauseRecurringInvoiceResponse500 = {
  data: Error
  status: 500
}

export type pauseRecurringInvoiceResponseSuccess = (pauseRecurringInvoiceResponse200) & {
  headers: Headers;
};
export type pauseRecurringInvoiceResponseError = (pauseRecurringInvoiceResponse400 | pauseRecurringInvoiceResponse401 | pauseRecurringInvoiceResponse403 | pauseRecurringInvoiceResponse404 | pauseRecurringInvoiceResponse422 | pauseRecurringInvoiceResponse500) & {
  headers: Headers;
};

export type pauseRecurringInvoiceResponse = (pauseRecurringInvoiceResponseSuccess | pauseRecurringInvoiceResponseError)

export const getPauseRecurringInvoiceUrl = (id: string,) => {


  

  return `/recurring-invoices/${id}/pause`
}

export const pauseRecurringInvoice = async (id: string, options?: RequestInit): Promise<pauseRecurringInvoiceResponse> => {
  
  return customFetch<pauseRecurringInvoiceResponse>(getPauseRecurringInvoiceUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Resume a paused recurring invoice schedule. The next run date is recalculated from the current date.
 * @summary Resume a paused recurring invoice
 */
export type resumeRecurringInvoiceResponse200 = {
  data: RecurringInvoice
  status: 200
}

export type resumeRecurringInvoiceResponse400 = {
  data: Error
  status: 400
}

export type resumeRecurringInvoiceResponse401 = {
  data: Error
  status: 401
}

export type resumeRecurringInvoiceResponse403 = {
  data: Error
  status: 403
}

export type resumeRecurringInvoiceResponse404 = {
  data: Error
  status: 404
}

export type resumeRecurringInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type resumeRecurringInvoiceResponse500 = {
  data: Error
  status: 500
}

export type resumeRecurringInvoiceResponseSuccess = (resumeRecurringInvoiceResponse200) & {
  headers: Headers;
};
export type resumeRecurringInvoiceResponseError = (resumeRecurringInvoiceResponse400 | resumeRecurringInvoiceResponse401 | resumeRecurringInvoiceResponse403 | resumeRecurringInvoiceResponse404 | resumeRecurringInvoiceResponse422 | resumeRecurringInvoiceResponse500) & {
  headers: Headers;
};

export type resumeRecurringInvoiceResponse = (resumeRecurringInvoiceResponseSuccess | resumeRecurringInvoiceResponseError)

export const getResumeRecurringInvoiceUrl = (id: string,) => {


  

  return `/recurring-invoices/${id}/resume`
}

export const resumeRecurringInvoice = async (id: string, options?: RequestInit): Promise<resumeRecurringInvoiceResponse> => {
  
  return customFetch<resumeRecurringInvoiceResponse>(getResumeRecurringInvoiceUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Manually trigger invoice generation for a recurring invoice schedule. Creates a new invoice immediately using the source document as template.
 * @summary Manually trigger invoice generation
 */
export type triggerRecurringInvoiceResponse200 = {
  data: RecurringInvoice
  status: 200
}

export type triggerRecurringInvoiceResponse400 = {
  data: Error
  status: 400
}

export type triggerRecurringInvoiceResponse401 = {
  data: Error
  status: 401
}

export type triggerRecurringInvoiceResponse403 = {
  data: Error
  status: 403
}

export type triggerRecurringInvoiceResponse404 = {
  data: Error
  status: 404
}

export type triggerRecurringInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type triggerRecurringInvoiceResponse500 = {
  data: Error
  status: 500
}

export type triggerRecurringInvoiceResponseSuccess = (triggerRecurringInvoiceResponse200) & {
  headers: Headers;
};
export type triggerRecurringInvoiceResponseError = (triggerRecurringInvoiceResponse400 | triggerRecurringInvoiceResponse401 | triggerRecurringInvoiceResponse403 | triggerRecurringInvoiceResponse404 | triggerRecurringInvoiceResponse422 | triggerRecurringInvoiceResponse500) & {
  headers: Headers;
};

export type triggerRecurringInvoiceResponse = (triggerRecurringInvoiceResponseSuccess | triggerRecurringInvoiceResponseError)

export const getTriggerRecurringInvoiceUrl = (id: string,) => {


  

  return `/recurring-invoices/${id}/trigger`
}

export const triggerRecurringInvoice = async (id: string, options?: RequestInit): Promise<triggerRecurringInvoiceResponse> => {
  
  return customFetch<triggerRecurringInvoiceResponse>(getTriggerRecurringInvoiceUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

